import { MapPin, Loader2 } from 'lucide-react';
import { AdminPageHeader, StatCard, useFetcher } from './_P1Common';

export default function AdminVisitorMap() {
  const { data, loading } = useFetcher('visitor-map');
  if (loading || !data) return <AdminPageHeader icon={MapPin} title="Karta posjetitelja"><Loader2 className="animate-spin"/></AdminPageHeader>;
  const max = Math.max(1, ...(data.items || []).map(i => i.visits));
  return (
    <div data-testid="admin-visitor-map">
      <AdminPageHeader icon={MapPin} title="Karta posjetitelja" subtitle="Distribucija posjeta po državama"/>
      <div className="px-4 md:px-6 mb-6 grid grid-cols-2 md:grid-cols-3 gap-3">
        <StatCard testid="vm-total" label="Ukupno posjeta" value={data.total} accent="blue"/>
        <StatCard testid="vm-countries" label="Broj država" value={(data.items || []).length} accent="violet"/>
      </div>
      <div className="px-4 md:px-6 pb-6 border border-zinc-800 rounded-lg mx-4 md:mx-6">
        <h3 className="px-4 py-2 border-b border-zinc-800 font-bold text-sm">Top 50 zemalja</h3>
        <ul className="divide-y divide-zinc-800">
          {(data.items || []).map(i => (
            <li key={i.country} className="px-4 py-2 text-sm">
              <div className="flex items-center justify-between mb-1">
                <span className="font-bold">{i.country}</span>
                <span className="text-red-400">{i.visits}</span>
              </div>
              <div className="h-1.5 bg-zinc-800 rounded"><div className="h-1.5 bg-red-600 rounded" style={{ width: `${(i.visits / max) * 100}%` }}/></div>
            </li>
          ))}
          {(data.items || []).length === 0 && <li className="px-4 py-8 text-center text-zinc-500">Nema podataka.</li>}
        </ul>
      </div>
    </div>
  );
}
